import { enumProxy } from 'app/libs/helpers'

export default enumProxy({
  postBoardShots: 'postBoardShots',
  postBoardModels: 'postBoardModels',
})
